import { combineReducers } from "@reduxjs/toolkit";
import visitor from "./visitorReducer"; // Assuming you already have a visitorReducer
import workflow from "./workflowReducer";

const index = combineReducers({
  visitor, // Add other reducers here as needed
  workflow,
});

export default index;
